import { render } from "./PlayerItem.vue?vue&type=template&id=18fed331&scoped=true"
import script from "./PlayerItem.vue?vue&type=script&lang=js"
export * from "./PlayerItem.vue?vue&type=script&lang=js"

import "./PlayerItem.vue?vue&type=style&index=0&id=18fed331&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18fed331"]])

export default __exports__